module.exports = __webpack_public_path__ + "img/download_icon_phone@3x.a6fc702f.png";